/**
 * @desc 确定实装信息出库
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinFactoryActualCabinetRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryScattered/outofStock`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
